import { styled } from "styled-components";
import { useState } from "react";
import { Divider, Input, Popover } from "antd";
import { IMessagePayload, chatType } from "@dataone/lib";

interface EntrepriseConnectorsListProps {
  messagePayLoad: IMessagePayload;
  setMessagePayLoad: (message: IMessagePayload) => void;
}

const EntrepriseConnectorsList = ({
  messagePayLoad,
  setMessagePayLoad,
}: EntrepriseConnectorsListProps) => {
  const [currentConnector, setCurrentConnector] = useState("");
  const handleConnectorClick = (connector: string) => {
    setCurrentConnector(connector);
    connector === "jira" &&
      setMessagePayLoad({
        ...messagePayLoad,
        chat: chatType.jira,
      });
  };
  // const handleChangeToken = (e: any) => {
  //   const token = e.target.value.trim();
  // };
  const [open, setOpen] = useState(false);
  // const hide = () => {
  //   setOpen(false);
  // };
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };
  const JiraContent = (
    <StyledContent>
      <StyledHeader>
        <img alt="logo" src="images/smart-search/chat/jira-icon.svg" />
        <Divider />
      </StyledHeader>
      <StyledSharedDiv>
        <p>
          1. Go to <span>slack website</span> and click Create APi Token.
        </p>
        <p>
          2. Enter a memorable and concise Label for your token and
          click Create.
        </p>
      </StyledSharedDiv>
    </StyledContent>
  );
  const SlackContent = (
    <StyledContent>
      <StyledHeader>
        <img alt="logo" src="images/smart-search/chat/slack-icon.svg" />
        <Divider />
      </StyledHeader>
      <StyledSharedDiv>
        <p>
          1. Go to <span>slack website</span> and click Create APi Token.
        </p>
        <p>
          2. Enter a memorable and concise Label for your token and
          click Create.
        </p>
      </StyledSharedDiv>
    </StyledContent>
  );

  const handleChangeURL = (e: any) => {
    const url = e.target.value.trim();
    if (url !== "") {
      setMessagePayLoad &&
        setMessagePayLoad({ ...messagePayLoad, workspaceUrl: e.target.value });
    }
  };

  const handleChangeEmail = (e: any) => {
    const email = e.target.value.trim();
    if (email !== "") {
      setMessagePayLoad &&
        setMessagePayLoad({ ...messagePayLoad, email: e.target.value });
    }
  };
  const handleChangeToken = (e: any) => {
    const token = e.target.value.trim();
    if (token !== "") {
      setMessagePayLoad &&
        setMessagePayLoad({ ...messagePayLoad, token: e.target.value });
    }
  };

  return (
    <>
      <StyledEntrepriseConnectorsList>
        <StyledCard>
          <div
            className={`connector-btn ${
              currentConnector === "slack"
                ? "active-connector"
                : "inactive-connector"
            }`}
            onClick={() => handleConnectorClick("slack")}
          >
            <img alt="logo" src="images/smart-search/chat/slack-icon.svg" />
          </div>
          <p>Slack</p>
        </StyledCard>
        <StyledCard>
          <div
            className={`connector-btn ${
              currentConnector === "jira"
                ? "active-connector"
                : "inactive-connector"
            }`}
            onClick={() => handleConnectorClick("jira")}
          >
            <img alt="logo" src="images/smart-search/chat/jira-icon.svg" />
          </div>
          <p>Jira</p>
        </StyledCard>
      </StyledEntrepriseConnectorsList>
      <div>
        {currentConnector === "jira" && (
          <StyledJiraInput>
            <StyledDataInput>
              <img
                alt="url"
                src="images/smart-search/chat/url-btn.svg"
                className="input-img"
              />
              <Input
                placeholder="Your URL"
                maxLength={255}
                value={messagePayLoad.workspaceUrl}
                onChange={handleChangeURL}
              />
            </StyledDataInput>
            <StyledDataInput>
              <img
                alt="url"
                src="images/smart-search/chat/mail-icon.svg"
                className="input-img"
              />
              <Input
                placeholder="Mail"
                maxLength={255}
                value={messagePayLoad.email}
                onChange={handleChangeEmail}
              />
            </StyledDataInput>
          </StyledJiraInput>
        )}
        {(currentConnector === "jira" || currentConnector === "slack") && (
          <StyledTokenInput>
            <img
              alt="url"
              src="images/smart-search/chat/entreprise-connectors-icon.svg"
              className="input-img"
            />
            <Input
              placeholder="API token"
              maxLength={255}
              value={messagePayLoad.token}
              onChange={handleChangeToken}
            />
            <StyledIcon>
              <Popover
                content={
                  currentConnector === "jira" ? JiraContent : SlackContent
                }
                placement="bottomRight"
                // title="Title"
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
              >
                <img alt="icon" src="images/smart-search/chat/help-icon.svg" />
              </Popover>
            </StyledIcon>
          </StyledTokenInput>
        )}
      </div>
    </>
  );
};

export default EntrepriseConnectorsList;

const StyledEntrepriseConnectorsList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 40px;
  width: 30px;
  img {
    height: 30px !important;
    position: relative !important;
  }
  p {
    font-size: 14px;
    font-weight: 600;
    text-overflow: ellipsis;
    width: 57px;
    overflow: hidden;
    white-space: nowrap;
  }
  .connector-btn {
    background: #fff;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    &:hover {
      background-color: #eff1fd;
      color: white;
      box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.25) inset;
      filter: none;
      border: none !important;
    }
  }
  .active-connector {
    border: 2px solid #4974f6;
  }
`;

const StyledTokenInput = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  width: 100%;
  .ant-input {
    border-radius: 26.5px;
    background: #eff1fd;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    height: 40px;
    font-size: 16px;
    padding-left: 53px;
    border: none;
    margin: 0px 20px;
  }
  .input-img {
    position: absolute;
    z-index: 1;
    height: 40px;
    margin-left: 20px;
  }
`;

const StyledIcon = styled.div`
  margin-left: auto;
  cursor: pointer;
  img {
    height: 20px !important;
    margin-top: 10px;
  }
`;

const StyledJiraInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledDataInput = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  width: 100%;
  .ant-input {
    border-radius: 26.5px;
    background: #eff1fd;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    height: 40px;
    font-size: 16px;
    padding-left: 53px;
    border: none;
    margin: 0px 20px;
  }
  .input-img {
    position: absolute;
    z-index: 1;
    height: 40px;
    margin-left: 20px;
  }
`;
const StyledSharedDiv = styled.div`
  p {
    color: #000;
    font-size: 15px;
    font-weight: 400;
    span {
      color: #4974f6;
    }
  }
`;
const StyledHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  img {
    height: 20px !important;
  }
  .ant-divider-horizontal {
    min-width: auto;
    background-color: #4974f6;
    height: 1px;
  }
`;
const StyledContent = styled.div`
  padding: 5px;
`;
